<template>
  <div class="pager-item" :class="{ selected }" @click="onClick">
    <h4>{{ title }}</h4>
    <p>{{ description }}</p>
    <div class="i">
      <span>i</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagerItem',
  props: {
    title: String,
    description: String,
    selected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick (e) {
      this.$emit('click', e)
    }
  }
}
</script>

<style scoped lang="scss">
.pager-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 100%;
  margin: 3rem 6rem;
  background-color: $color-yellow;
  color: $color-white;
  user-select: none;

  &::before {
    content: " ";
    display: block;
    position: absolute;
    top: -3rem;
    left: -4.5rem;
    width: calc(100% + 9rem);
    height: calc(100% + 6rem);
    background-color: inherit;
    transform: skew(-10deg, 0);
  }

  &::after {
    content: " ";
    display: block;
    position: absolute;
    bottom: 0;
    left: calc(50% - 3rem);
    width: 4.8rem;
    height: 4.8rem;
    transform: rotate(45deg);
    background-color: inherit;
    transition: bottom 200ms;
  }

  &.selected::after {
    bottom: -4.8rem;
  }

  & > * {
    position: relative;
    z-index: 1;
  }

  h4 {
    margin-bottom: 0.6rem;
  }

  p {
    margin-bottom: 3rem;
  }
}

.i {
  position: relative;
  display: inline-block;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  font-family: serif;
  font-size: 3rem;
  font-weight: 700;
  line-height: 6rem;
  color: $color-white;
  background-color: inherit;

  &::before {
    content: " ";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: inherit;
    filter: brightness(0.85);
    transition: filter 100ms;
  }

  &:hover {
    cursor: pointer;

    &::before {
      filter: brightness(0.9);
    }
  }

  &:active {
    transform: translateY(.2rem);
  }

  span {
    position: relative;
    z-index: 1;
  }
}
</style>
